import { httpAuthService } from "../Api/http.service";
import { getApiBaseUrl } from "utils";

// Get dynamic base URL based on selected country
const getAuthBaseUrl = () => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}/appcore/auth`;
};

const getSSOBaseUrl = () => `${getApiBaseUrl()}/appcore/public/sso`;

const signIn = (payload) =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/login`,
    method: "post",
    data: payload,
  });

const signOut = () =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/logout`,
    method: "post",
  });

const resetPassword = (payload) =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/reset-password`,
    method: "post",
    data: payload,
  });

const confirmResetPassword = (payload) =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/confirm-reset-password`,
    method: "post",
    data: payload,
  });

const confirmSignIn = (payload) =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/challenge`,
    method: "post",
    data: payload,
  });

const fetchAuthSession = (payload) =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/refresh`,
    method: "post",
    data: payload,
  });

const fetchUserAttributes = () =>
  httpAuthService({
    url: `${getAuthBaseUrl()}/user-attributes`,
    method: "post",
  });

const ssoExchangeToken = (payload) =>
  httpAuthService({
    url: `${getSSOBaseUrl()}/authorize`,
    method: "post",
    data: payload,
  });

const authInit = (payload) =>
  httpAuthService({
    url: `${getSSOBaseUrl()}/auth/init`,
    method: "post",
    data: payload,
  });

export {
  signIn,
  signOut,
  resetPassword,
  confirmResetPassword,
  confirmSignIn,
  fetchAuthSession,
  fetchUserAttributes,
  ssoExchangeToken,
  authInit,
};
